module.exports = __webpack_public_path__ + "static/img/27.a3027af.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/27.png
// module id = dMBN
// module chunks = 1